import { useContext } from 'react'
import { AppContext } from '../../contextApi/ContextApi';
import TrafficChart from '../TrafficChart';

export default function AdminStatistics({admin, theme}) {
  const { calculateDaysPassed } = useContext(AppContext);
  const errorMsg = "חלה שגיאה בטעינת המידע";
  var domains= [
  {
    name:"com",
    amount:0,  
  },
  {
    name:"website",
    amount:0,  
  },
  {
    name:"site",
    amount:0,  
  },
  {
    name:"org",
    amount:0,  
  },
  {
    name:"net",
    amount:0,  
  },
  {
    name:"app",
    amount:0,  
  },
  {
    name:"tech",
    amount:0,  
  },
  {
    name:"online",
    amount:0,  
  },
  {
    name:"store",
    amount:0,  
  },
  {
    name:"shop",
    amount:0,  
  },
  {
    name:"bizz",
    amount:0,  
  },
  {
    name:"info",
    amount:0,  
  }];
  const statisticsRecord = {
    websitesCreated:admin?.websites?.length || errorMsg,
    newWebsites:admin?.websites?.filter((web)=>{
      const daysExists = calculateDaysPassed(web.createdAt);
      if(daysExists <= 7){
        return web;
      }
      return null;
    }) || errorMsg,
    mostVisited:admin?.websites.sort((a, b)=> b?.logs?.length-a?.logs?.length),
    totalUsers: admin?.websites.map(web=>{
      return {
        webName:web?.settings?.domain,
        webID:web?.id,
        users: web?.settings?.clients
      }
    }).sort((a, b)=> b?.users?.length - a?.users?.length),
    totalProducts:admin?.websites.map(web=>{
      return {
        webName:web?.settings?.domain,
        webID:web?.id,
        products:web?.settings?.categories.flatMap(cat=>cat?.products)
      }
    }).sort((a, b)=> b?.products?.length - a?.products?.length),
    bestSubDomains:domains?.map((domain)=>{
      admin?.websites?.map((web)=>{
        if(web?.settings?.domain?.split(".")[1]===domain.name){
          domain.amount++;
        }
        return web;
      })
      return domain;
    }).sort((a,b)=>b.amount-a.amount),
    
    websitesActivity:admin?.websites?.map((web)=>{
      var logsThisMonth = 0;
      web?.logs.map((log)=>{
        if(calculateDaysPassed(log.createdAt)<=30)logsThisMonth++;
        return log;
      })
      return {
        webID:web?.id,
        webName:web?.settings?.domain,
        activityStatus:logsThisMonth===0?"Unactive" : logsThisMonth<=5?"Low Activity" : logsThisMonth<=20?"Average Activity" : logsThisMonth<=50?"Active" : "High Activity"
      }
    })
    // ====================================
    // might be good for the website itself:
    // top selling products for the website
    // average orders per website
    // total orders
    // ====================================
    // database requests traffic? - need to hold it like the logs and create new request onject on each time the client call a function to the firebase
    // storage usage on firebase
    
  }
  console.log("Admin Data: ",statisticsRecord)
  return (
    <div className='adminStatistics'>
      <h1 style={{margin:"0",color:theme.accent_color, textShadow:`2px 2px 4px ${theme.primary_color}`, fontSize:"50px"}}>סטטיסטיקות ונתונים</h1>
      <h2 style={{marginTop:"50px",color:theme.accent_color, textShadow:`1px 1px 3px ${theme.primary_color}`, fontSize:"30px"}}>מס' אתרים שנוצרו - {statisticsRecord?.websitesCreated}</h2>
      <TrafficChart backgroundColor={theme.accent_color} stepSize={1} label={"תת דומיין מוביל"} hasTitle={true} title={"תת דומיין מוביל"} lables={statisticsRecord?.bestSubDomains?.map(s=>s.name)} values={[ ...statisticsRecord?.bestSubDomains?.map(s=>s.amount), statisticsRecord?.bestSubDomains[0].amount+1]} barThickness={25} type={"Bar"} dataBackgroundColor={theme.primary_color} borderColor={theme.accent_color} legendColor={theme.primary_color} xTicksColor={theme.primary_color} yTicksColor={theme.primary_color} hasXTitleText={true} hasYTitleText={true} xTitleText={"Sub-Domains"} yTitleText={"Amount"}/>

      <TrafficChart backgroundColor={theme.accent_color} stepSize={1} label={"כמות מוצרים לאתר"} hasTitle={true} title={"כמות מוצרים לאתר"} lables={statisticsRecord?.totalProducts?.map(s=>s.webName)} values={[ ...statisticsRecord?.totalProducts?.map(s=>s?.products?.length), statisticsRecord?.totalProducts[0].products.length+1]} barThickness={25} type={"Bar"} dataBackgroundColor={theme.primary_color} borderColor={theme.accent_color} legendColor={theme.primary_color} xTicksColor={theme.primary_color} yTicksColor={theme.primary_color} hasXTitleText={true} hasYTitleText={true} xTitleText={"Websites Names"} yTitleText={"Amount"}/>

      <TrafficChart backgroundColor={theme.accent_color} stepSize={1} label={"סך משתמשים רשומים לאתר"} hasTitle={true} title={"סך משתמשים רשומים לאתר"} lables={statisticsRecord?.totalUsers?.map(s=>s.webName)} values={[ ...statisticsRecord?.totalUsers?.map(s=>s?.users?.length), statisticsRecord?.totalUsers[0].users.length+1]} barThickness={25} type={"Bar"} dataBackgroundColor={theme.primary_color} borderColor={theme.accent_color} legendColor={theme.primary_color} xTicksColor={theme.primary_color} yTicksColor={theme.primary_color} hasXTitleText={true} hasYTitleText={true} xTitleText={"Websites Names"} yTitleText={"Amount"}/>
    </div>
  )
}
